/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { PREFIX } from '.';

// --- Permits
export const FETCH_PERMIT = `${PREFIX}FETCH_PERMIT`;
export const RESET_PERMIT = `${PREFIX}RESET_PERMIT`;
export const FETCH_RECAREA = `${PREFIX}FETCH_RECAREA`;

// --- Availability
export const FETCH_AVAILABILITY = `${PREFIX}FETCH_AVAILABILITY`;
export const FETCH_AVAILABILITY_API = `${PREFIX}FETCH_AVAILABILITY_API`;
export const RESET_AVAILABILITY = `${PREFIX}RESET_AVAILABILITY`;

// --- Reservations
export const ADD_RESERVATION = `${PREFIX}ADD_RESERVATION`;
export const UPDATE_RESERVATION = `${PREFIX}UPDATE_RESERVATION`;
export const FETCH_RESERVATION = `${PREFIX}FETCH_RESERVATION`;
export const RESET_RESERVATION = `${PREFIX}RESET_RESERVATION`;
export const INPROGRESS_UPDATE_RESERVATION = `${PREFIX}INPROGRESS_UPDATE_RESERVATION`;

// -- Validations
export const SET_VALIDATION_ERROR = `${PREFIX}SET_VALIDATION_ERROR`;
export const DISPLAY_UI_VALIDATIONS = `${PREFIX}DISPLAY_UI_VALIDATIONS`;
export const CLEAR_VALIDATION_ERROR = `${PREFIX}CLEAR_VALIDATION_ERROR`;

// --- Lottery
export const FETCH_LOTTERIES = `${PREFIX}FETCH_LOTTERIES`;
export const FETCH_LOTTERY_ISSUANCE = `${PREFIX}FETCH_LOTTERY_RESERVATION`;
export const FETCH_LOTTERY = `${PREFIX}FETCH_LOTTERY`;
export const CANCEL_LOTTERY_ISSUANCE = `${PREFIX}CANCEL_LOTTERY_RESERVATION`;
export const ACCEPT_LOTTERY_ISSUANCE = `${PREFIX}ACCEPT_LOTTERY_ISSUANCE`;
export const ADD_LOTTERY_APPLICATION = `${PREFIX}ADD_LOTTERY_APPLICATION`;

// --- SEASONS
export const FETCH_SEASONS = `${PREFIX}FETCH_SEASONS`;
